import { CoreModule } from "src/app/core/core.module";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NrTablesComponent } from "./nr-tables/nr-tables.component";
import { TableFilterSearchComponent } from "./table-filter-search/table-filter-search.component";
import { MaterialModule } from "../core/modules/material.module";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { StylePaginatorDirective } from "./directives/pagination-style.directive";
import { TableComponent } from "./table/table.component";
import { TableFilterOnColumnComponent } from "./table-filter-on-column/table-filter-on-column.component";
import { TableFilterServersideComponent } from "./table-filter-serverside/table-filter-serverside.component";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { TagComponent } from "./tag/tag.component";

@NgModule({
  declarations: [
    NrTablesComponent,
    TableFilterSearchComponent,
    StylePaginatorDirective,
    TableComponent,
    TableFilterOnColumnComponent,
    TableFilterServersideComponent,
    TagComponent,
  ],
  imports: [
    CoreModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    ScrollingModule,
  ],
  exports: [
    MaterialModule,
    NrTablesComponent,
    TableFilterSearchComponent,
    StylePaginatorDirective,
    TableComponent,
    TableFilterOnColumnComponent,
    TableFilterServersideComponent,
    ScrollingModule,
    TagComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
